import FastClick from 'fastclick';
import $ from 'jquery';

FastClick.attach(document.body);

setTimeout(function() {
  $('body').addClass('is-loaded');
}, 100);



// WEBPACK FOOTER //
// ./src/_assets/js/modules/site.js